import UserTableAccessor from "../../components/common/UserTableAccessor";

const createdByColumn = (onIdSelect, Header = "Created By") => ({
  id: "createdBy",
  Header,
  accessor: UserTableAccessor("createdBy", onIdSelect),
});

export default createdByColumn;
